export const emptyForm = ({commit}) => {
  return new Promise((resolve, reject) => {
    commit('SET_EMAIL', null)
    commit('SET_EMITED', 'event')
    commit('SET_READ', 'event')
    commit('SET_EDITED', 'event')
    commit('SET_REFUSED', 'event')
    commit('SET_ACCEPTED', 'event')
    commit('SET_IGNORED', 'event')
    resolve()
  })
}
